
import classNames from 'classnames'
import { Article, Articlev2 } from 'models/article'
import Link from 'next/link'
import { useRouter } from 'next/router';
import { PropsWithClassAndStyle } from 'utils/props'

export function ArticleCard({ article: { id, metadata: { name, description } }, className, style, onClick }: PropsWithClassAndStyle<{ article: Articlev2; link?: string; onClick?: (id: string) => void }>) {
  const router = useRouter()

  return <article className={classNames("flex flex-row p-2 border border-light-grey rounded-xl", className)} style={style}>
    <div className="flex flex-col w-full gap-1  max-w-xl">
      <div className="flex flex-col gap-0.5">
        <button className="flex truncate" onClick={() => {
          if (!onClick) router.push(`/articles/${id}`)
          else onClick(id)
        }}><h2 className="text-2xl text-link font-semibold truncate">{name}</h2></button>
        <p className="break-word text-grey line-clamp-3">{description}</p>
      </div>
      {/* {tags.length > 0 && <div className="flex flex-row gap-0.5">{tags.map(t => <ArticleTag name={t} key={t} />)}</div>} */}
    </div>
  </article>
}

